import { Translations } from '../types/i18n';

export const translations: Translations = {
  en: {
    site: {
      title: "Monument Valley 3 Guide",
      description: "Complete walkthrough guide with all chapters and levels",
      keywords: "Monument Valley 3, MV3 walkthrough, game guide, impossible architecture"
    },
    navigation: {
      home: "Home",
      chapters: "Chapters",
      about: "About",
      menu: "Menu"
    },
    home: {
      title: "Monument Valley 3 Complete Guide",
      subtitle: "Master impossible architecture with our comprehensive video walkthrough guide. All chapters, levels, and solutions for iOS and Android.",
      chapters: "Chapters",
      levels: "Impossible Levels",
      solutions: "Video Solutions",
      exploreChapters: "Explore Chapters",
      aboutGuide: "About Guide",
      videoTitle: "Complete Video Walkthrough",
      videoDescription: "Watch the full Monument Valley 3 walkthrough in stunning detail. Every puzzle solved, every secret revealed. Master all 9 chapters with our step-by-step video guide.",
      gameTitle: "About Monument Valley 3",
      gameDescription: "Monument Valley 3 is a puzzle adventure game where you manipulate impossible architecture and optical illusions to guide the silent princess Ida through beautiful monuments. Experience stunning visuals, mind-bending puzzles, and a captivating storyline.",
      features: {
        title: "Key Features",
        opticalIllusions: {
          name: "Optical Illusions",
          desc: "Manipulate perspective to reveal hidden paths"
        },
        impossibleArchitecture: {
          name: "Impossible Architecture",
          desc: "Navigate mind-bending structures"
        },
        beautifulArt: {
          name: "Beautiful Art",
          desc: "Stunning visual design and aesthetics"
        },
        intuitiveControls: {
          name: "Intuitive Controls",
          desc: "Simple yet engaging gameplay mechanics"
        }
      },
      exploreAllChapters: "Explore All Chapters"
    },
    chapters: {
      title: "Chapter Selection",
      chapter: "Chapter",
      level: "Level",
      difficulty: "Difficulty",
      easy: "Easy",
      medium: "Medium",
      hard: "Hard"
    },
    game: {
      title: "Monument Valley 3",
      description: "An impossible architecture puzzle game where you manipulate optical illusions to guide silent princess Ida through beautiful monuments.",
      downloadFromAppStore: "Download from App Store",
      downloadFromGooglePlay: "Download from Google Play",
      features: {
        title: "Game Features",
        opticalIllusions: "Optical Illusions",
        impossibleArchitecture: "Impossible Architecture",
        beautifulArt: "Beautiful Art Style",
        intuitiveControls: "Intuitive Controls"
      },
      chaptersList: {
        title: "Available Chapters",
        extravaganza: "Extravaganza - Begin your journey",
        gardens: "The Gardens - Explore surreal landscapes",
        city: "The City - Navigate urban architecture",
        temple: "The Temple - Discover ancient secrets",
        beyond: "Beyond Reality - Transcend perception"
      }
    },
    level: {
      backToChapters: "← Back to Chapters",
      videoSolution: "Video Solution",
      clickToPlay: "Click to Play Video",
      tags: "Tags",
      completed: "Completed"
    }
  },

  ko: {
    site: {
      title: "모뉴먼트 밸리 3 가이드",
      description: "모든 챕터와 레벨이 포함된 완벽한 공략 가이드",
      keywords: "모뉴먼트 밸리 3, MV3 공략, 게임 가이드, 불가능한 건축"
    },
    navigation: {
      home: "홈",
      chapters: "챕터",
      about: "소개",
      menu: "메뉴"
    },
    home: {
      title: "모뉴먼트 밸리 3 완벽 가이드",
      subtitle: "불가능한 건축을 마스터하세요! 포괄적인 비디오 워크스루 가이드로 iOS와 Android용 모든 챕터, 레벨, 솔루션을 제공합니다.",
      chapters: "챕터",
      levels: "불가능한 레벨",
      solutions: "비디오 해결책",
      exploreChapters: "챕터 탐색",
      aboutGuide: "가이드 소개",
      videoTitle: "완전한 비디오 워크스루",
      videoDescription: "놀라운 디테일로 모뉴먼트 밸리 3 전체 워크스루를 시청하세요. 모든 퍼즐을 해결하고 모든 비밀을 발견하세요. 단계별 비디오 가이드로 모든 9개 챕터를 마스터하세요.",
      gameTitle: "모뉴먼트 밸리 3 소개",
      gameDescription: "모뉴먼트 밸리 3은 불가능한 건축과 광학적 착시를 조작하여 무녀 이다를 아름다운 기념물을 통해 안내하는 퍼즐 어드벤처 게임입니다. 놀라운 비주얼, 마음을 사로잡는 퍼즐, 매력적인 스토리라인을 경험하세요.",
      features: {
        title: "주요 특징",
        opticalIllusions: {
          name: "광학적 착시",
          desc: "시각을 조작하여 숨겨진 길을 발견하세요"
        },
        impossibleArchitecture: {
          name: "불가능한 건축",
          desc: "마음을 사로잡는 구조를 탐색하세요"
        },
        beautifulArt: {
          name: "아름다운 아트",
          desc: "놀라운 비주얼 디자인과 미학"
        },
        intuitiveControls: {
          name: "직관적인 조작",
          desc: "간단하지만 매력적인 게임 플레이 메커니즘"
        }
      },
      exploreAllChapters: "모든 챕터 탐색"
    },
    chapters: {
      title: "챕터 선택",
      chapter: "챕터",
      level: "레벨",
      difficulty: "난이도",
      easy: "쉬움",
      medium: "보통",
      hard: "어려움"
    },
    game: {
      title: "모뉴먼트 밸리 3",
      description: "광학적 착시를 조작하여 무녀 이다를 아름다운 기념물을 통해 안내하는 불가능한 건축 퍼즐 게임.",
      downloadFromAppStore: "앱 스토어에서 다운로드",
      downloadFromGooglePlay: "구글 플레이에서 다운로드",
      features: {
        title: "게임 특징",
        opticalIllusions: "광학적 착시",
        impossibleArchitecture: "불가능한 건축",
        beautifulArt: "아름다운 아트 스타일",
        intuitiveControls: "직관적인 조작"
      },
      chaptersList: {
        title: "이용 가능한 챕터",
        extravaganza: "엑스트라바간자 - 여정 시작",
        gardens: "가든 - 초현실적 풍경 탐험",
        city: "시티 - 도시 건축 탐색",
        temple: "템플 - 고대 비밀 발견",
        beyond: "비욘드 리얼리티 - 지각 초월"
      }
    },
    level: {
      backToChapters: "← 챕터로 돌아가기",
      videoSolution: "비디오 해결책",
      clickToPlay: "클릭하여 비디오 재생",
      tags: "태그",
      completed: "완료됨"
    }
  },

  ja: {
    site: {
      title: "モニュメントバレー3ガイド",
      description: "すべての章とレベルを含む完全なウォークスルーガイド",
      keywords: "モニュメントバレー3, MV3攻略, ゲームガイド, 不可能な建築"
    },
    navigation: {
      home: "ホーム",
      chapters: "チャプター",
      about: "について",
      menu: "メニュー"
    },
    home: {
      title: "モニュメントバレー3完全ガイド",
      subtitle: "不可能な建築をマスターしましょう！包括的なビデオウォークスルーガイドで、iOSとAndroid向けのすべてのチャプター、レベル、ソリューションを提供します。",
      chapters: "チャプター",
      levels: "不可能なレベル",
      solutions: "ビデオ解決策",
      exploreChapters: "チャプター探索",
      aboutGuide: "ガイドについて",
      videoTitle: "完全なビデオウォークスルー",
      videoDescription: "驚くほど詳細なモニュメントバレー3の完全ウォークスルーをご覧ください。すべてのパズルを解決し、すべての秘密を発見しましょう。ステップバイステップのビデオガイドで、すべての9チャプターをマスターできます。",
      gameTitle: "モニュメントバレー3について",
      gameDescription: "モニュメントバレー3は、不可能な建築と光学錯覚を操作して、美しい記念碑を通じて無口な姫イダを導くパズルアドベンチャーゲームです。驚くべきビジュアル、心を揺さぶるパズル、魅力的なストーリーラインを体験してください。",
      features: {
        title: "主な特徴",
        opticalIllusions: {
          name: "光学錯覚",
          desc: "視点を操作して隠された道を明らかにしましょう"
        },
        impossibleArchitecture: {
          name: "不可能な建築",
          desc: "心を揺さぶる構造をナビゲートしましょう"
        },
        beautifulArt: {
          name: "美しいアート",
          desc: "驚くべきビジュアルデザインと美学"
        },
        intuitiveControls: {
          name: "直感的な操作",
          desc: "シンプルながら魅力的なゲームプレイメカニクス"
        }
      },
      exploreAllChapters: "すべてのチャプターを探索"
    },
    chapters: {
      title: "チャプター選択",
      chapter: "チャプター",
      level: "レベル",
      difficulty: "難易度",
      easy: "簡単",
      medium: "普通",
      hard: "難しい"
    },
    game: {
      title: "モニュメントバレー3",
      description: "光学錯覚を操作して、美しい記念碑を通じて無口な姫イダを導く不可能な建築パズルゲーム。",
      downloadFromAppStore: "App Storeからダウンロード",
      downloadFromGooglePlay: "Google Playからダウンロード",
      features: {
        title: "ゲームの特徴",
        opticalIllusions: "光学錯覚",
        impossibleArchitecture: "不可能な建築",
        beautifulArt: "美しいアートスタイル",
        intuitiveControls: "直感的な操作"
      },
      chaptersList: {
        title: "利用可能なチャプター",
        extravaganza: "エクストラバガンザ - 旅の始まり",
        gardens: "ガーデン - 超現実的な風景の探索",
        city: "シティ - 都市建築のナビゲーション",
        temple: "テンプル - 古代の秘密の発見",
        beyond: "ビヨンドリアリティ - 知覚の超越"
      }
    },
    level: {
      backToChapters: "← チャプターに戻る",
      videoSolution: "ビデオ解決策",
      clickToPlay: "クリックしてビデオ再生",
      tags: "タグ",
      completed: "完了"
    }
  },

  zh: {
    site: {
      title: "纪念碑谷3攻略指南",
      description: "包含所有章节和关卡的完整攻略指南",
      keywords: "纪念碑谷3, MV3攻略, 游戏指南, 不可能建筑"
    },
    navigation: {
      home: "首页",
      chapters: "章节",
      about: "关于",
      menu: "菜单"
    },
    home: {
      title: "纪念碑谷3完整攻略",
      subtitle: "掌握不可能建筑！通过我们的综合视频通关指南，掌握iOS和Android的所有章节、关卡和解决方案。",
      chapters: "章节",
      levels: "不可能关卡",
      solutions: "视频解决方案",
      exploreChapters: "探索章节",
      aboutGuide: "关于指南",
      videoTitle: "完整视频通关",
      videoDescription: "观看令人惊叹的纪念碑谷3完整通关。解决所有谜题，揭示所有秘密。通过我们的分步视频指南掌握所有9个章节。",
      gameTitle: "关于纪念碑谷3",
      gameDescription: "纪念碑谷3是一款益智冒险游戏，您可以通过操控不可能建筑和视觉错觉，引导沉默的公主艾达穿越美丽的纪念碑。体验令人惊叹的视觉效果、令人费解的谜题和引人入胜的故事情节。",
      features: {
        title: "主要特色",
        opticalIllusions: {
          name: "视觉错觉",
          desc: "操控视角以揭示隐藏路径"
        },
        impossibleArchitecture: {
          name: "不可能建筑",
          desc: "探索令人费解的结构"
        },
        beautifulArt: {
          name: "精美艺术",
          desc: "令人惊叹的视觉设计和美学"
        },
        intuitiveControls: {
          name: "直观控制",
          desc: "简单而引人入胜的游戏机制"
        }
      },
      exploreAllChapters: "探索所有章节"
    },
    chapters: {
      title: "章节选择",
      chapter: "章节",
      level: "关卡",
      difficulty: "难度",
      easy: "简单",
      medium: "中等",
      hard: "困难"
    },
    game: {
      title: "纪念碑谷3",
      description: "一款操控视觉错觉引导沉默公主艾达穿越美丽纪念碑的不可能建筑解谜游戏。",
      downloadFromAppStore: "从App Store下载",
      downloadFromGooglePlay: "从Google Play下载",
      features: {
        title: "游戏特色",
        opticalIllusions: "视觉错觉",
        impossibleArchitecture: "不可能建筑",
        beautifulArt: "美丽艺术风格",
        intuitiveControls: "直观控制"
      },
      chaptersList: {
        title: "可用章节",
        extravaganza: "盛宴 - 开始你的旅程",
        gardens: "花园 - 探索超现实景观",
        city: "城市 - 穿越城市建筑",
        temple: "神庙 - 发现古代秘密",
        beyond: "超越现实 - 超越感知"
      }
    },
    level: {
      backToChapters: "← 返回章节",
      videoSolution: "视频解决方案",
      clickToPlay: "点击播放视频",
      tags: "标签",
      completed: "已完成"
    }
  },

  ru: {
    site: {
      title: "Руководство Monument Valley 3",
      description: "Полное руководство прохождения со всеми главами и уровнями",
      keywords: "Monument Valley 3, MV3 прохождение, игровое руководство, невозможная архитектура"
    },
    navigation: {
      home: "Главная",
      chapters: "Главы",
      about: "О нас",
      menu: "Меню"
    },
    home: {
      title: "Monument Valley 3 Полное Руководство",
      subtitle: "Освойте невозможную архитектуру с нашим всеобъемлющим видеоруководством. Все главы, уровни и решения для iOS и Android.",
      chapters: "Главы",
      levels: "Невозможные уровни",
      solutions: "Видеорешения",
      exploreChapters: "Исследовать главы",
      aboutGuide: "О руководстве",
      videoTitle: "Полное Видеоруководство",
      videoDescription: "Смотрите полное прохождение Monument Valley 3 в потрясающих деталях. Каждая загадка решена, каждая тайна раскрыта. Освойте все 9 глав с нашим пошаговым видеоруководством.",
      gameTitle: "О Monument Valley 3",
      gameDescription: "Monument Valley 3 - это игра-головоломка, в которой вы манипулируете невозможной архитектурой и оптическими иллюзиями, чтобы провести безмолвную принцессу Иду через красивые памятники. Испытайте потрясающую графику, увлекательные головоломки и захватывающий сюжет.",
      features: {
        title: "Ключевые особенности",
        opticalIllusions: {
          name: "Оптические иллюзии",
          desc: "Манипулируйте перспективой, чтобы открыть скрытые пути"
        },
        impossibleArchitecture: {
          name: "Невозможная архитектура",
          desc: "Навигируйте по сложным структурам"
        },
        beautifulArt: {
          name: "Красивое искусство",
          desc: "Потрясающий визуальный дизайн и эстетика"
        },
        intuitiveControls: {
          name: "Интуитивное управление",
          desc: "Простые, но увлекательные игровые механики"
        }
      },
      exploreAllChapters: "Исследовать все главы"
    },
    chapters: {
      title: "Выбор главы",
      chapter: "Глава",
      level: "Уровень",
      difficulty: "Сложность",
      easy: "Легко",
      medium: "Средне",
      hard: "Сложно"
    },
    game: {
      title: "Monument Valley 3",
      description: "Головоломка с невозможной архитектурой, где вы манипулируете оптическими иллюзиями, чтобы провести безмолвную принцессу Иду через красивые памятники.",
      downloadFromAppStore: "Скачать из App Store",
      downloadFromGooglePlay: "Скачать из Google Play",
      features: {
        title: "Особенности игры",
        opticalIllusions: "Оптические иллюзии",
        impossibleArchitecture: "Невозможная архитектура",
        beautifulArt: "Красивый стиль",
        intuitiveControls: "Интуитивное управление"
      },
      chaptersList: {
        title: "Доступные главы",
        extravaganza: "Экстраваганца - Начните свое путешествие",
        gardens: "Сады - Исследуйте сюрреалистические пейзажи",
        city: "Город - Навигируйте по городской архитектуре",
        temple: "Храм - Откройте древние секреты",
        beyond: "За пределами реальности - Выходите за рамки восприятия"
      }
    },
    level: {
      backToChapters: "← Вернуться к главам",
      videoSolution: "Видеорешение",
      clickToPlay: "Нажмите для воспроизведения видео",
      tags: "Теги",
      completed: "Завершено"
    }
  }
};